/**
 * PitchBook Admin API
 * PitchBook Admin OpenAPI specification
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import {createAction} from '@reduxjs/toolkit';
import {ApiMethods, ConcurrentStrategies} from '@pb/middleware-api';
import {PayloadData} from '../types';
import type {Error} from '../models/Error';

export interface GetAccountDomains$Request {
    accountId: number;
}

export interface GetAccountDomains$Config {
    bulk?: boolean;
    concurrentStrategy?: typeof ConcurrentStrategies[keyof typeof ConcurrentStrategies];
    signal?: AbortSignal;
}

export const getAccountDomainsRequest = createAction<PayloadData<void, GetAccountDomains$Request>>('GET_ACCOUNT_DOMAINS__GET_ACCOUNT_DOMAINS__REQUEST');
export const getAccountDomainsSuccess = createAction<PayloadData<Array<string>, GetAccountDomains$Request>>('GET_ACCOUNT_DOMAINS__GET_ACCOUNT_DOMAINS__SUCCESS');
export const getAccountDomainsFailure = createAction<PayloadData<Error, GetAccountDomains$Request, true>>('GET_ACCOUNT_DOMAINS__GET_ACCOUNT_DOMAINS__FAILURE');

export const getAccountDomainsActions = [
    getAccountDomainsRequest,
    getAccountDomainsSuccess,
    getAccountDomainsFailure
] as const;

/**
 * @param {number} meta.accountId
 * @param {boolean} [config.bulk]
 * @param {typeof ConcurrentStrategies[keyof typeof ConcurrentStrategies]} [config.concurrentStrategy]
 * @param {AbortSignal} [config.signal]
 */
export const getAccountDomains = (meta: GetAccountDomains$Request, config?: GetAccountDomains$Config) => {
    return {
        CALL_API: {
            types: getAccountDomainsActions,
            method: ApiMethods.GET,
            endpoint: `/web-api/accounts/${meta.accountId}/domains`,
            bulk: config?.bulk,
            concurrentStrategy: config?.concurrentStrategy,
            signal: config?.signal,
            headers: {
                'Accept': 'application/json',
            }
        },
        ...meta
    }
};

